export { default } from './bitcoin-banner';
